export default __webpack_public_path__ + "static/media/mc-qr-android.0b97f033.png";